<div [hidden]="isEditing" [ngClass]="cedente && cedente.Padrao ? 'cedente padrao card col-md-12' : 'cedente card col-md-12'">
  <div class="row radio-padrao">
    <input (change)="cedentePadrao()" [checked]="cedente.Padrao" id={{cedente.CedenteId}} type="radio" class="styled-radio">
    <label for={{cedente.CedenteId}}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <title></title>
        <polyline points="4 8 7 11 12 6" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
      </svg>
    </label>

    <span *ngIf="cedente.Padrao">Este é seu cedente atual</span>

    <span class="error-message">{{errorMessage}}</span>
  </div>

  <form class="row">
    <div class="col-sm-2">
      <div *ngFor="let banco of bancos">
          <div [hidden]="banco.number !== cedente.Banco" [ngClass]="banco.number === cedente.Banco ? cedente.Padrao ? 'logo-banco ' + banco.className : 'logo-banco ' + banco.className + ' grayscale' : 'logo-banco'"></div>
      </div>
    </div>

    <!-- Banco do Brasil -->
    <div class="col-sm-8" *ngIf="cedente.Banco === '001'">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Banco</label>
            <h5 *ngFor="let banco of bancos" class="mar-no">{{ cedente.Banco === banco.number ? banco.name : null }}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Agência</label>
            <h5 class="mar-no">{{cedente.Agencia}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Conta</label>
            <h5 class="mar-no">{{cedente.ContaNumero}}-{{cedente.ContaDigito}}</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Número de Cedente</label>
            <h5 class="mar-no">{{cedente.NumeroCedente}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Código do Convênio</label>
            <h5 class="mar-no">{{cedente.CodigoConvenio}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Carteira</label>
            <h5 class="mar-no">{{cedente.Carteira}}</h5>
          </div>
        </div>
      </div>
    </div>

    <!-- Bradesco -->
    <div class="col-sm-8" *ngIf="cedente.Banco === '237'">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Banco</label>
            <h5 *ngFor="let banco of bancos" class="mar-no">{{ cedente.Banco === banco.number ? banco.name : null }}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Agência</label>
            <h5 class="mar-no">{{cedente.Agencia}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Conta</label>
            <h5 class="mar-no">{{cedente.ContaNumero}}-{{cedente.ContaDigito}}</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Número de Cedente</label>
            <h5 class="mar-no">{{cedente.NumeroCedente}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Carteira</label>
            <h5 class="mar-no">{{cedente.Carteira}}</h5>
          </div>
        </div>
      </div>
    </div>

    <!-- Santander -->
    <div class="col-sm-8" *ngIf="cedente.Banco === '033'">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Banco</label>
            <h5 *ngFor="let banco of bancos" class="mar-no">{{ cedente.Banco === banco.number ? banco.name : null }}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Agência</label>
            <h5 class="mar-no">{{cedente.Agencia}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Conta</label>
            <h5 class="mar-no">{{cedente.ContaNumero}}-{{cedente.ContaDigito}}</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Número de Cedente</label>
            <h5 class="mar-no">{{cedente.NumeroCedente}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Código do Convênio</label>
            <h5 class="mar-no">{{cedente.CodigoConvenio}}</h5>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Código de Transmissão</label>
            <h5 class="mar-no">{{cedente.CodigoTransmissao}}</h5>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group" animate="fadeIn" delay="300">
            <label for="" class="control-label">Carteira</label>
            <h5 class="mar-no">{{cedente.Carteira}}</h5>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>


<div [hidden]="!isEditing" class="card col-md-12 animate-card-down-cedente">
  <form (ngSubmit)="submit($event)">
    <div class="col-md-10">
      <div>
        <div class="row text-left">
          <div class="col-sm-4">
            <select class="config-cedente-banco" [(ngModel)]="cedente.Banco" name="Banco">
              <option *ngFor="let banco of bancos" [value]="banco.number">{{banco.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Bradesco -->
      <div *ngIf="cedente.Banco === '237'">
        <div class="row text-left">
          <div class="col-sm-3">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Agencia</label>
              <input class="form-control" type="text" [(ngModel)]="cedente.Agencia" name="Agencia">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Nº Cedente</label>
              <input class="form-control" type="text" [(ngModel)]="cedente.NumeroCedente" name="NumeroCedente">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-4">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Conta</label>
              <input class="form-control" type="text" [(ngModel)]="cedente.ContaNumero" name="ContaNumero">
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Dígito</label>
              <input class="form-control" type="text" [(ngModel)]="cedente.ContaDigito" name="ContaDigito">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-3">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Carteira</label>
              <input class="form-control" type="text" [(ngModel)]="cedente.Carteira" name="Carteira">
            </div>
          </div>
        </div>

        <div class="row text-left">
          <div class="col-sm-12">
            <div class="form-group" animate="fadeIn" delay="300">
              <label for="" class="control-label">Descrição</label>
              <input class="form-control" type="text" [(ngModel)]="cedente.Descricao" name="Descrição">
            </div>
          </div>
        </div>
      </div>

      <!-- Santander -->
      <div *ngIf="cedente.Banco === '033'">
          <div class="row text-left">
            <div class="col-sm-3">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Agencia</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.Agencia" name="Agencia">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Conta</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.ContaNumero" name="ContaNumero">
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Dígito</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.ContaDigito" name="ContaDigito">
              </div>
            </div>
          </div>

          <div class="row text-left">
            <div class="col-sm-4">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Cod. Convênio</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.CodigoConvenio" name="CodigoConvenio">
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Cod. Transmissão</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.CodigoTransmissao" name="CodigoTransmissao">
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Carteira</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.Carteira" name="Carteira">
              </div>
            </div>
          </div>

          <div class="row text-left">
            <div class="col-sm-12">
              <div class="form-group" animate="fadeIn" delay="300">
                <label for="" class="control-label">Descrição</label>
                <input class="form-control" type="text" [(ngModel)]="cedente.Descricao" name="Descrição">
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="col-md-2">
      <button [ngClass]="isLoading ? 'btn btn-grey loading pull-right' : 'btn btn-grey pull-right'">Salvar</button>
    </div>
  </form>
</div>
